import { render, staticRenderFns } from "./RuPrivacyPolicy.vue?vue&type=template&id=482d7be5&scoped=true"
import script from "./RuPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./RuPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "482d7be5",
  null
  ,true
)

export default component.exports